export default "__VITE_ASSET__e81148f6__"